import { useEffect, useState } from "react";
import { CallHistory } from "../../../../service/models/complaint_model";
import { X } from "react-feather";

interface EditHistoryModalProps {
  history: CallHistory | null;
  isOpen: boolean;
  onClose: () => void;
  onSave: (history: CallHistory) => void;
}

const EditHistoryModal: React.FC<EditHistoryModalProps> = ({
  history,
  isOpen,
  onClose,
  onSave,
}) => {
  const [formData, setFormData] = useState<CallHistory>(
    history || ({} as CallHistory)
  );

  useEffect(() => {
    if (history && isOpen) {
      setFormData({ ...history });
    }
  }, [history, isOpen]);

  const handleSubmit = () => {
    onSave({ ...formData });
    onClose();
  };

  if (!isOpen || !history) return null;
  return (
    <div id="incident_tracker_edit_history_modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Edit Call History</h2>
          <button
            id="incident_tracker_edit_history_modal_close_btn"
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={24} />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Followup ID
            </label>
            <input
              id="incident_tracker_edit_history_followup_id"
              type="text"
              value={formData.followupIncidentId}
              onChange={(e) =>
                setFormData({ ...formData, followupIncidentId: e.target.value })
              }
              className="w-full border rounded px-3 py-2"
              disabled
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Answered By
            </label>
            <input
              id="incident_tracker_edit_history_answered_by"
              type="text"
              value={formData.answered_by}
              onChange={(e) =>
                setFormData({ ...formData, answered_by: e.target.value })
              }
              className="w-full border rounded px-3 py-2"
              disabled
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Remark</label>
            <textarea
              id="incident_tracker_edit_history_remark"
              value={formData.remark}
              onChange={(e) =>
                setFormData({ ...formData, remark: e.target.value })
              }
              className="w-full border rounded px-3 py-2 h-24"
            />
          </div>
          <div className="flex justify-end space-x-2">
            <button
              id="incident_tracker_edit_history_cancel_btn"
              onClick={onClose}
              className="px-4 py-2 border rounded hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              id="incident_tracker_edit_history_save_btn"
              onClick={handleSubmit}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHistoryModal;
